module.exports = __webpack_public_path__ + "assets/img/thumb-Cluey-Learning-2-Landing-Page-+-Website.7916c5f2.jpg";